<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-form style="padding-bottom: 50px;">
			<van-field v-model="form.client_name" name="客户姓名" label="客户姓名" readonly />
			<van-field v-model="form.client_status_text" name="客户状态" label="客户状态" readonly />
			<van-field v-model="form.contact_person" name="联系人" label="联系人" readonly />
			<van-field v-model="form.contact_phone" name="联系电话" label="联系电话" readonly />
			<van-field v-model="form.other_methods" name="其他联系方式" label="其他联系方式" readonly />
			<van-field v-model="form.address" name="地址" label="地址" readonly />
			<van-field v-model="form.client_job_text" name="客户职位" label="客户职位" readonly />
			<van-field v-model="form.tag_id_text" name="客户标签" label="客户标签" readonly />
			<van-field v-model="form.client_type_text" name="客户类型" label="客户类型" readonly />
			<van-field v-model="form.client_remark" rows="3" autosize label="备注" type="textarea" readonly />
		</van-form>

		<!-- <van-tabbar v-model="activeName">
			<van-tabbar-item name="list" icon="user-o" to="/customer/list">我的客户</van-tabbar-item>
			<van-tabbar-item name="public" icon="friends-o" to="/customer/publicList">公共客户</van-tabbar-item>
			<van-tabbar-item name="index" icon="add-o" to="/customer/index">新增客户</van-tabbar-item>
		</van-tabbar>-->
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { customer, tagList } from "@/api/customer";
import { Toast } from "vant";

export default {
	name: "customer",
	components: {
		navbar
	},
	data() {
		return {
			title: "客户详情",
			activeName: "list",
			client_id: this.$route.query.id,
			form: {},
			typeList: [
				{ text: "意向客户", id: 0 },
				{ text: "现场确认尺寸和方案", id: 1 },
				{ text: "已做报价及方案", id: 2 },
				{ text: "需要配合招投标", id: 3 },
				{ text: "待签订合同", id: 4 },
				{ text: "已签订合同", id: 5 },
				{ text: "跟单失败客户", id: 6 }
			],
			clientTypeList: [
				{ text: "工程商", id: 0 },
				{ text: "千店服务商", id: 1 },
				{ text: "中间商", id: 2 },
				{ text: "业主客户", id: 3 },
				{ text: "强力经销商调货", id: 4 }
			],
			clientJobList: [
				{ text: "高层管理", id: 0 },
				{ text: "中层管理", id: 1 },
				{ text: "普通对接人员", id: 2 }
			],
			tagIdList: []
		};
	},
	mounted() {
		this.getTagList();
	},
	methods: {
		getTagList() {
			tagList({
				requestType: "get_customer_tag"
			})
				.then(res => {
					this.tagIdList = res.obj;
					this.getCustomer();
				})
				.catch(() => {
					Toast.fail("数据异常");
				});
		},
		getCustomer() {
			customer({
				requestType: "client_follow_list",
				client_id: this.client_id
			})
				.then(res => {
					console.log(res);
					this.form = res.obj;
					this.form.client_job_text = this.clientJobList[
						res.obj.client_job
					].text;
					this.form.client_status_text = this.typeList[
						res.obj.client_status
					].text;
					this.form.client_type_text = this.clientTypeList[
						res.obj.client_type
					].text;
					this.form.tag_id_text = this.tagIdList[
						res.obj.tag_id
					].tag_name;
				})
				.catch(() => {
					Toast.fail("数据异常");
				});
		}
	}
};
</script>

<style>
</style>
